<template>
  <v-container grid-list-xl>
    <v-layout flex-child wrap v-if="totals.number_of_customers > 0">
      <v-flex md4 xs12 d-flex>
        <material-card color="Cyan" title="Dados da Conta" text="">
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 d-flex>
                <table>
                  <tr>
                    <td>Valor a Pagar</td>
                    <td class="text-lg-right">
                      R$ {{ totals.valor_conta || 0 | formatCurrency }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <hr />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>Leitura Anterior</td>
                    <td class="text-lg-right">
                      {{ totals.data_leitura_anterior }}
                    </td>
                  </tr>
                  <tr>
                    <td>Leitura Atual</td>
                    <td class="text-lg-right">
                      {{ totals.data_leitura_atual }}
                    </td>
                  </tr>
                  <tr>
                    <td>Próxima Leitura</td>
                    <td class="text-lg-right">
                      {{ totals.data_leitura_proxima }}
                    </td>
                  </tr>
                  <tr>
                    <td>Quantidade de Dias</td>
                    <td class="text-lg-right">
                      {{ totals.dias_leitura || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td>Resp. Custo de Disp.</td>
                    <td class="text-lg-right">
                      {{ totals.cobraCustoDisp ? "Cliente" : "Usina" }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>
      </v-flex>
      <v-spacer />
      <v-flex xs12 md8 d-flex>
        <material-card color="Cyan" title="Auditoria (kWh)" text="">
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 d-flex>
                <table>
                  <tr>
                    <th class="text-lg-left"></th>
                    <th class="text-lg-right">Usina</th>
                    <th class="text-lg-right">Processado</th>
                    <th class="text-lg-right">%</th>
                  </tr>
                  <tr>
                    <td class="text-lg-left">Membros</td>
                    <td class="text-lg-right">
                      {{ totals.number_of_customers | formatNumber }}
                    </td>
                    <td class="text-lg-right">
                      {{ totals.total_clientes | formatNumber }}
                    </td>
                    <td class="text-lg-right">
                      {{
                        (totals.total_clientes / totals.number_of_customers)
                          | formatPercent
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4"><hr size="1" /></td>
                  </tr>
                  <tr>
                    <td class="text-lg-left">Créditos</td>
                    <td class="text-lg-right">
                      {{ totals.power_plant_amount | formatNumber }}
                    </td>
                    <td class="text-lg-right">
                      {{ totals.total_amount_kw | formatNumber }}
                    </td>
                    <td class="text-lg-right">
                      {{
                        (totals.total_amount_kw / totals.power_plant_amount)
                          | formatPercent
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-lg-left">Consumo</td>
                    <td class="text-lg-right">
                      {{
                        totals.power_plant_consumption_kW * -1 ||
                        0 | formatNumber
                      }}
                    </td>
                    <td class="text-lg-right"></td>
                    <td class="text-lg-right"></td>
                  </tr>
                  <tr>
                    <td class="text-lg-left">Saldo</td>
                    <td class="text-lg-right">
                      {{
                        (totals.last_balance - totals.current_balance)
                          | formatNumber
                      }}
                    </td>
                    <td class="text-lg-right"></td>
                    <td class="text-lg-right"></td>
                  </tr>
                  <tr>
                    <td colspan="4"><hr size="1" /></td>
                  </tr>
                  <tr>
                    <td class="text-lg-left title">Total</td>
                    <td class="text-lg-right title">
                      {{ total_planta || 0 | formatNumber }}
                    </td>
                    <td class="text-lg-right title">
                      {{ processado | formatNumber }}
                    </td>
                    <td class="text-lg-right title">
                      {{ (processado / total_planta) | formatPercent }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>
      </v-flex>
    </v-layout>
    <v-layout flex-child wrap v-if="totals.number_of_customers > 0">
      <material-card
        color="teal"
        title="Dados Financeiros (R$)"
        text=""
        style="width: 100%"
      >
        <v-container py-0>
          <v-layout>
            <v-flex xs12 md12 lg12>
              <table style="width: 100%">
                <tr>
                  <th class="text-lg-left"></th>
                  <th class="text-lg-right">Créditos</th>
                  <th class="text-lg-right">Desconto</th>
                  <th class="text-lg-right" v-if="!totals.cobraCustoDisp">
                    Custo Disp
                  </th>
                  <th class="text-lg-right">Receita Bruta</th>
                  <th class="text-lg-right">Taxas</th>
                  <th class="text-lg-right">Receita Líquida</th>
                  <th class="text-lg-right">Quitado</th>
                  <th class="text-lg-right">Pendente</th>
                  <th class="text-lg-right">Não Faturado</th>
                </tr>
                <tr v-for="owner in totals.powerplant.owners" :key="owner.name">
                  <td class="title">
                    {{ owner.name }}
                    <p>
                      <small>({{ owner.percentage | formatPercent }})</small>
                    </p>
                  </td>
                  <td class="text-lg-right">
                    {{
                      (totals.total_creditos * owner.percentage)
                        | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right" v-if="!totals.cobraCustoDisp">
                    ({{
                      (totals.total_desconto * 1 -
                        totals.total_custo_disp * 1 * owner.percentage)
                        | formatCurrency
                    }})
                  </td>
                  <td class="text-lg-right" v-else>
                    ({{
                      (totals.total_desconto * 1 * owner.percentage)
                        | formatCurrency
                    }})
                  </td>
                  <td class="text-lg-right" v-if="!totals.cobraCustoDisp">
                    ({{
                      (totals.total_custo_disp * owner.percentage)
                        | formatCurrency
                    }})
                  </td>
                  <td class="text-lg-right">
                    {{
                      (totals.total_faturado * owner.percentage)
                        | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right">
                    ({{
                      (totals.total_fees * owner.percentage) | formatCurrency
                    }})
                  </td>
                  <td class="text-lg-right">
                    {{
                      ((totals.total_faturado * 1 - totals.total_fees * 1) *
                        owner.percentage)
                        | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right">
                    {{
                      (totals.total_pago * 1 - totals.total_fees * 1) *
                        owner.percentage || 0 | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right">
                    {{
                      (totals.total_pendente * 1 - totals.total_fees * 1) *
                        owner.percentage || 0 | formatCurrency
                    }}
                  </td>
                  <!-- <td class="text-lg-right"> {{nao_faturado>0?nao_faturado:nao_faturado * -1 || 0 * owner.percentage || 0 | formatCurrency}}</td> -->
                  <td class="text-lg-right">
                    ({{
                      totals.total_nao_faturado ||
                      0 * owner.percentage ||
                      0 | formatCurrency
                    }})
                  </td>
                </tr>
                <tr>
                  <td colspan="10"><hr size="1" /></td>
                </tr>
                <tr>
                  <td class="title">Total</td>
                  <td class="text-lg-right title">
                    {{ totals.total_creditos | formatCurrency }}
                  </td>
                  <td class="text-lg-right title" v-if="!totals.cobraCustoDisp">
                    ({{
                      (totals.total_desconto * 1 - totals.total_custo_disp * 1)
                        | formatCurrency
                    }})
                  </td>
                  <td class="text-lg-right title" v-else>
                    ({{ (totals.total_desconto * 1) | formatCurrency }})
                  </td>
                  <td class="text-lg-right title" v-if="!totals.cobraCustoDisp">
                    ({{ totals.total_custo_disp | formatCurrency }})
                  </td>
                  <td class="text-lg-right title">
                    {{ totals.total_faturado | formatCurrency }}
                  </td>
                  <td class="text-lg-right title">
                    ({{ totals.total_fees | formatCurrency }})
                  </td>
                  <td class="text-lg-right title">
                    {{
                      (totals.total_faturado * 1 - totals.total_fees * 1)
                        | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right title">
                    {{
                      (totals.total_pago * 1 - totals.total_fees * 1)
                        | formatCurrency
                    }}
                  </td>
                  <td class="text-lg-right title">
                    {{
                      (totals.total_pendente * 1 - totals.total_fees * 1)
                        | formatCurrency
                    }}
                  </td>
                  <!-- <td class="text-lg-right title">{{nao_faturado>0?nao_faturado:nao_faturado * -1 || 0 | formatCurrency}}</td> -->
                  <td class="text-lg-right title">
                    ({{ totals.total_nao_faturado || 0 | formatCurrency }})
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-container>
      </material-card>
    </v-layout>
    <v-layout flex-child wrap v-if="totals.number_of_customers > 0">
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="green"
          icon="mdi-credit-card"
          title="Cartão de Crédito"
          subtitle="R$"
          small-value="R$"
          :value="totals.total_cartao || 0 | formatCurrency"
          :sub-text="
            totals.total_cartao /
              (totals.total_faturado * 1 - totals.total_fees * 1) ||
            0 | formatPercent
          "
          sub-text-color="text-success"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="orange"
          icon="mdi-barcode"
          title="Boleto"
          :value="totals.total_boleto || 0 | formatCurrency"
          small-value="R$"
          :sub-text="
            totals.total_boleto /
              (totals.total_faturado * 1 - totals.total_fees * 1) ||
            0 | formatPercent
          "
          sub-text-color="text-success"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="blue"
          icon="mdi-coin"
          title="Economia Gerada"
          :value="totals.total_economia || 0 | formatCurrency"
          sub-icon="mdi-tag"
          small-value="R$"
          sub-text="Satisfação de nossos membros"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
export default {
  // props: ['totals'],
  data: () => ({
    totals: {},
    total_planta: 0,
    nao_faturado: 0,
    processado: 0,
  }),
  mounted() {
    EventBus.$on("InvoiceTotal", (invoiceTotal) => {
      this.totals = invoiceTotal;

      const saldo = invoiceTotal.last_balance - invoiceTotal.current_balance;
      if (saldo > 0) {
        this.total_planta =
          invoiceTotal.power_plant_amount -
          invoiceTotal.power_plant_consumption_kW;
        this.processado = invoiceTotal.total_amount_kw;
      } else {
        this.total_planta =
          invoiceTotal.power_plant_amount -
          invoiceTotal.power_plant_consumption_kW +
          saldo;
        this.processado = invoiceTotal.total_amount_kw;
      }
      this.nao_faturado =
        invoiceTotal.total_faturado * 1 -
        invoiceTotal.total_fees * 1 -
        invoiceTotal.total_pago * 1 -
        invoiceTotal.total_pendente * 1;
    });
  },
  filters: {
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatNumber(value) {
      let val = (value * 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercent(value) {
      let val = (value * 100).toFixed(2).replace(".", ",");
      return val + "%";
    },
  },
};
</script>
<style scoped>
.quadro2degrad {
  background: #c0c0c0;
}
</style>
